import React from "react";

const SmartButton = ({
  text,
  loadingText = "Processing...",
  successText = "Success!",
  state = "default", // default, success, error
  disabled = false,
  onClick,
  type = "submit",
  className = "",
  isSubmitting = false, // To differentiate between loading and success
  icon = null, // Custom icon prop
}) => {
  const getButtonText = () => {
    if (isSubmitting) {
      return loadingText; // Show loading text when submitting, but with success styling
    }
    switch (state) {
      case "success":
        return successText;
      case "error":
        return text; // Keep original text for error state
      default:
        return text;
    }
  };

  const getButtonIcon = () => {
    // Use custom icon if provided, otherwise use default logic
    if (icon) {
      if (isSubmitting) {
        return "hourglass_empty"; // Show loading icon when submitting
      }
      switch (state) {
        case "success":
          return "check_circle";
        case "error":
          return icon; // Keep custom icon for error state
        default:
          return icon;
      }
    }

    // Default behavior when no custom icon is provided
    if (isSubmitting) {
      return "hourglass_empty"; // Show loading icon when submitting
    }
    switch (state) {
      case "success":
        return "check_circle";
      case "error":
        return "arrow_forward"; // Keep original arrow icon for error state
      default:
        return "arrow_forward";
    }
  };

  // Compose className, adding state variants when needed
  const cls = [
    "cta-button",
    "primary",
    disabled || isSubmitting ? "disabled" : "",
    state === "success" ? "success" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const isDisabled = disabled || isSubmitting;

  return (
    <button
      className={cls}
      disabled={isDisabled}
      onClick={onClick}
      type={type}
    >
      <b>{getButtonText()}</b>
      {isSubmitting && <span className="spinner"></span>}
    </button>
  );
};

export default SmartButton;
